// ─────────────────────────────────────────────────────────────────
// Glass-i — Thickness Master API client (Stage 6B.8A-3K.1).
//
// Thin axios wrappers around /api/erp/masters/thicknesses/*. Used
// by ThicknessMasterPage AND by ProcessMasterPage (to load the
// active thickness columns).
// ─────────────────────────────────────────────────────────────────

import client from '../../../../api/client';

const BASE = '/api/erp/masters/thicknesses';

function unwrap(resp) {
  return resp && resp.data && resp.data.data !== undefined
    ? resp.data.data
    : resp && resp.data;
}

export const thicknessMasterApi = {
  list:    (params = {}) => client.get(BASE, { params }).then(unwrap),
  get:     (id)          => client.get(`${BASE}/${encodeURIComponent(id)}`).then(unwrap),
  create:  (payload)     => client.post(BASE, payload).then(unwrap),
  update:  (id, payload) => client.put(`${BASE}/${encodeURIComponent(id)}`, payload).then(unwrap),
  remove:  (id)          => client.delete(`${BASE}/${encodeURIComponent(id)}`).then(unwrap),
  reorder: (payload)     => client.post(`${BASE}/reorder`, payload).then(unwrap)
};

// Convenience for callers that just need the active thickness mm
// values, sorted ascending by sort_order then value.
export async function listActiveThicknessesMm() {
  const out = await thicknessMasterApi.list({ isActive: true, limit: 200 });
  return (out && Array.isArray(out.rows) ? out.rows : [])
    .map((r) => Number(r.thicknessMm))
    .filter((n) => Number.isFinite(n) && n > 0);
}

export default thicknessMasterApi;
